import React from 'react';
import './App.css'; // Asegúrate de importar Tailwind CSS
import Index from './Views/Index';
import Login from './Views/Login';
import { AuthProvider, useAuth } from './AuthContext';

function App() {
  return (
    <AuthProvider>
      <MainContent />
    </AuthProvider>
  );
}

function MainContent() {
  const { isLoggedIn, login, logout, loginError, user } = useAuth();
  

  return (
    <div>
      {isLoggedIn  ? (
        <Index onLogout={logout} user={user} /> // Si el usuario está logueado, muestra el componente Home
      ) : (
        <Login onLogin={login} error={loginError} /> // Si no, muestra Login y pasa la función login como prop
      )}
    </div>
  );
}

export default App;
